<script setup lang="ts">
import type { PropType } from 'vue'
import type { THomeSectionAnimation } from '~/layers/homepage/data/types'

defineProps({
  section: {
    type: Object as PropType<THomeSectionAnimation>,
    required: true,
  },
})
</script>

<template>
  <div class="fixed-panel fixed-panel__panel">
    <div class="fixed-panel__body">
      <div class="fixed-panel__header">
        <p class="fixed-panel__subtitle">{{ section.navigation.title }}</p>
      </div>
      <div class="fixed-panel__content">
        <img alt="" class="fixed-panel__diamond" :src="$h.externalAsset(section.navigation.icon)" />
        <p class="fixed-panel__text">
          {{ $h.typograph(section.navigation.description) }}
        </p>
      </div>
      <div class="fixed-panel__footer">
        <nuxt-link :to="section.navigation.buttonLink" class="fixed-panel__link">
          {{ section.navigation.buttonText }}
        </nuxt-link>
      </div>
    </div>
  </div>
</template>
